import React from 'react';
import './itp-motociclete-atv.css';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Link } from 'react-router-dom';
import {
  FaShieldAlt,
  FaClock,
  FaCheckCircle,
  FaCertificate,
  FaMotorcycle,
  FaGlobe,
  FaUserCog,
  FaCogs,
  FaPhoneAlt,
  FaMapMarkerAlt,
  FaClipboardCheck,
  FaIdCard,
  FaFileAlt,
  FaFileContract,
  FaFileSignature
} from 'react-icons/fa';

// Imagini specifice moto/ATV — de înlocuit cu fotografii proprii din service
const images = {
  hero: "https://images.pexels.com/photos/2611686/pexels-photo-2611686.jpeg",
  qualified: "https://images.pexels.com/photos/13065690/pexels-photo-13065690.jpeg",
  zoneServicii: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTmpI8Hcqan_WZdH_SCFMZQa0ae0FeKx09a9B0JX2sHjA&s=10",
  zoneAproape: "https://images.pexels.com/photos/2116475/pexels-photo-2116475.jpeg",
  priceScutere: "https://images.pexels.com/photos/2611686/pexels-photo-2611686.jpeg",
  priceMoto: "https://images.pexels.com/photos/1119796/pexels-photo-1119796.jpeg",
  priceAtv: "https://images.pexels.com/photos/12915513/pexels-photo-12915513.jpeg"
};

// Date structurate (Schema.org) — ajută la afișarea corectă în Google pentru căutări locale
const jsonLd = {
  "@context": "https://schema.org",
  "@type": "AutoRepair",
  "name": "ITP Motociclete & ATV Sector 2",
  "areaServed": [
    "Sector 2 București", "Pantelimon", "Colentina", "Obor", "Iancului",
    "Titan", "Vitan", "Baicului", "Doamna Ghica", "Fundeni"
  ],
  "priceRange": "RON",
  "telephone": "+40726104358"
};

const ItpMotoAtvPage = () => {
  return (
    <div className="itp-moto-layout">
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>

      <Navbar />

      {/* HERO */}
      <section className="moto-hero">
        <div className="moto-hero-container">
          <div className="moto-hero-image-side">
            <img
              src={images.hero}
              alt="ITP motociclete si ATV Sector 2 - statie autorizata RAR"
              className="moto-hero-image"
            />
          </div>
          <div className="moto-hero-text-side">
            <span className="itp-eyebrow"><FaMotorcycle /> Stație ITP moto & ATV autorizată RAR</span>
            <h1>ITP Motociclete și ATV Sector 2 București</h1>
            <p>
              Căutai un service pentru <strong>ITP moto Sector 2</strong>? Efectuăm <strong>inspecția tehnică periodică</strong> pentru
              motociclete, scutere, ATV-uri și cvadricicluri, indiferent de cilindree, cu emiterea pe loc a certificatului ITP.
            </p>
            <p>
              Stația noastră de <strong>ITP ATV București</strong> este dotată cu linie de testare dedicată două și patru roți
              (frâne, direcție, iluminare, noxe) și mecanici autorizați RAR. Acoperim rapid clienții din <strong>Sector 2</strong> și
              zonele apropiate: Pantelimon, Colentina, Obor, Iancului și Titan.
            </p>

            <div className="moto-trust-row">
              <span className="moto-trust-chip"><FaShieldAlt /> Autorizare RAR</span>
              <span className="moto-trust-chip"><FaClock /> Verificare în aceeași vizită</span>
              <span className="moto-trust-chip"><FaCheckCircle /> Preț fix pe categorie</span>
            </div>

            <a href="tel:+40726104358" className="btn-ticket"><FaPhoneAlt /> Programează ITP moto/ATV</a>
          </div>
        </div>
      </section>

      {/* DE CE SĂ NE ALEGI */}
      <section className="moto-why-section">
        <div className="moto-why-header">
          <span className="itp-eyebrow">De ce noi</span>
          <h2>Echipă dedicată pentru două și patru roți</h2>
          <p>Nu tratăm o motocicletă ca pe o mașină mică. Avem standuri și proceduri gândite special pentru moto și ATV.</p>
        </div>
        <div className="moto-why-grid">
          <div className="moto-why-card">
            <div className="moto-why-icon"><FaGlobe /></div>
            <h3>Standarde RAR</h3>
            <p>Verificări conforme cu normativele Registrului Auto Român, valabile pentru circulația pe drumurile publice din România.</p>
          </div>
          <div className="moto-why-card">
            <div className="moto-why-icon"><FaUserCog /></div>
            <h3>Mecanici specializați moto/ATV</h3>
            <p>Echipa noastră lucrează frecvent cu motociclete, scutere și ATV-uri, cunoscând particularitățile fiecărei categorii.</p>
          </div>
          <div className="moto-why-card">
            <div className="moto-why-icon"><FaCogs /></div>
            <h3>Verificare completă</h3>
            <p>Testăm frânele, direcția, suspensia, iluminarea și emisiile, pentru un certificat ITP fără surprize la drum.</p>
          </div>
        </div>
      </section>

      {/* CUM FUNCȚIONEAZĂ */}
      <section className="moto-process-section">
        <div className="moto-process-header">
          <span className="itp-eyebrow">Proces simplu</span>
          <h2>Cum funcționează programarea</h2>
          <p>Patru pași, fără drumuri inutile prin Sector 2.</p>
        </div>
        <div className="moto-process-grid">
          <div className="moto-process-step">
            <div className="moto-process-num"><FaPhoneAlt /></div>
            <h3>Suni sau completezi programarea</h3>
            <p>Alegi categoria vehiculului: moto, scuter sau ATV.</p>
          </div>
          <div className="moto-process-step">
            <div className="moto-process-num"><FaMapMarkerAlt /></div>
            <h3>Vii în stația din Sector 2</h3>
            <p>Aproape de Pantelimon, Colentina și Obor.</p>
          </div>
          <div className="moto-process-step">
            <div className="moto-process-num"><FaClipboardCheck /></div>
            <h3>Verificare tehnică RAR</h3>
            <p>Testăm frâne, direcție, iluminare și emisii.</p>
          </div>
          <div className="moto-process-step">
            <div className="moto-process-num"><FaCertificate /></div>
            <h3>Primești certificatul ITP</h3>
            <p>Eliberat pe loc, valabil la nivel național.</p>
          </div>
        </div>
      </section>

      {/* ECHIPĂ CALIFICATĂ */}
      <section className="moto-qualified-section">
        <div className="moto-qualified-container">
          <div className="moto-qualified-image-side">
            <img src={images.qualified} alt="Mecanic verificand o motocicleta la ITP Sector 2" />
            <div className="moto-qualified-badge"><FaShieldAlt /> Stație autorizată RAR</div>
          </div>
          <div className="moto-qualified-text-side">
            <h2>Calificați și cu experiență pe segmentul moto/ATV</h2>
            <p>
              De la scutere de oraș la ATV-uri de teren, aplicăm aceeași rigoare tehnică pentru fiecare
              <strong> ITP motociclete</strong> și <strong>ITP ATV</strong> efectuat în stația din Sector 2.
            </p>
            <ul className="moto-checklist">
              <li><FaCheckCircle /> Test frâne pe stand dedicat</li>
              <li><FaCheckCircle /> Verificare direcție & suspensie</li>
              <li><FaCheckCircle /> Control iluminare & semnalizare</li>
              <li><FaCheckCircle /> Test emisii poluante</li>
            </ul>
          </div>
        </div>
      </section>

      {/* TARIFE */}
      <section className="moto-prices-section">
        <div className="moto-prices-header">
          <span className="itp-eyebrow">Tarife 2026</span>
          <h2>Tarife ITP Motociclete & ATV Sector 2</h2>
          <p>Prețuri fixe, pe categorie de vehicul, fără costuri ascunse.</p>
        </div>
        <div className="moto-prices-grid">

          <div className="moto-price-card">
            <img className="moto-price-image" src={images.priceScutere} alt="ITP scutere si motociclete pana la 125cc" />
            <div className="moto-price-content">
              <h3>Scutere & Moto până la 125cc</h3>
              <p className="moto-price-tag">200 <span>RON</span></p>
              <p className="moto-price-details">Verificare tehnică completă pentru scutere și motociclete cu cilindree redusă, folosite în oraș.</p>
              <button className="moto-btn-price"><a href="tel:+40726104358">Programează-te</a></button>
            </div>
          </div>

          <div className="moto-price-card popular">
            <img className="moto-price-image" src={images.priceMoto} alt="ITP motociclete peste 125cc" />
            <div className="moto-price-content">
              <h3>Motociclete peste 125cc</h3>
              <p className="moto-price-tag">200 <span>RON</span></p>
              <p className="moto-price-details">Include verificare frâne, suspensie și emisii pentru motociclete de tură și sport.</p>
              <button className="moto-btn-price"><a href="tel:+40726104358">Programează-te</a></button>
            </div>
          </div>

          <div className="moto-price-card">
            <img className="moto-price-image" src={images.priceAtv} alt="ITP ATV si cvadricicluri grele" />
            <div className="moto-price-content">
              <h3>ATV </h3>
              <p className="moto-price-tag">200 <span>RON</span></p>
              <p className="moto-price-details">Testare specifică pentru ATV-uri utilitare și cvadricicluri cu tracțiune integrală.</p>
              <button className="moto-btn-price"><a href="tel:+40726104358">Programează-te</a></button>
            </div>
          </div>

        </div>
      </section>

      {/* ZONE ACOPERITE */}
      <section className="moto-zones-section">
        <div className="moto-zones-container">
          <div className="moto-zone-card">
            <div className="moto-zone-image-wrapper">
              <img src={images.zoneServicii} alt="Servicii ITP moto Sector 2" />
            </div>
            <h3>SERVICII MOTO/ATV</h3>
            <p>Autorizați RAR pentru <strong>ITP Sector 2</strong>, cu clienți frecvenți și din <strong>Sector 1</strong> și <strong>Sector 3</strong>.</p>
            <Link to="/" className="moto-btn-minimal" style={{ textDecoration: 'none', display: 'inline-block' }}>Citește mai mult</Link>
          </div>
          <div className="moto-zone-card">
            <div className="moto-zone-image-wrapper">
              <img src={images.zoneAproape} alt="ITP moto aproape de mine Sector 2" />
            </div>
            <h3>ITP MOTO APROAPE DE MINE</h3>
            <p>La câteva minute de <strong>Pantelimon</strong>, <strong>Colentina</strong>, <strong>Obor</strong>, <strong>Iancului</strong> și <strong>Titan</strong>.</p>
            <Link to="/" className="moto-btn-minimal" style={{ textDecoration: 'none', display: 'inline-block' }}>Citește mai mult</Link>
          </div>
        </div>
      </section>

      {/* ACTE NECESARE */}
      <section className="moto-docs-section">
        <h2>Acte necesare pentru ITP moto/ATV:</h2>
        <div className="moto-docs-grid">
          <div className="moto-doc-item"><FaFileAlt /><span>Cartea de identitate a vehiculului (CIV)</span></div>
          <div className="moto-doc-item"><FaFileContract /><span>Talonul / Certificatul de înmatriculare</span></div>
          <div className="moto-doc-item"><FaFileSignature /><span>Asigurarea RCA valabilă</span></div>
          <div className="moto-doc-item"><FaIdCard /><span>Actul de identitate (CI) al proprietarului</span></div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ItpMotoAtvPage;